import * as React from 'react';
import { UIHeading1, UIHeading2, UIText1, useDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IAboutSdelkaItemProps {
  icon: string;
  title: string;
  label?: React.ReactNode;
  description: string;
}

export const AboutSdelkaItem: React.FC<IAboutSdelkaItemProps> = ({ icon, title, label, description }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';
  const HeadingComponent = isDesktop ? UIHeading1 : UIHeading2;

  return (
    <div className={styles['item']}>
      <div className={styles['title']}>
        <img src={icon} alt={title} />

        <div>
          <HeadingComponent color="text-primary-default">{title}</HeadingComponent>

          {label && <div className={styles['label']}>{label}</div>}
        </div>
      </div>

      <div className={styles['description']}>
        <UIText1 color="text-secondary-default">{description}</UIText1>
      </div>
    </div>
  );
};
